const getDeviceStateInfo = (state) => ({
  type: state.type,
  data: state.data,
})

export default getDeviceStateInfo
